import { applyFiltersToSearchResults, defaultClassFilters } from '../utils';
import { PRICE_FILTER_STEP } from '../../../utils/constants';
import { convertDateToMilliseconds, MILLISECONDS_IN_AN_HOUR } from '../../../utils/timeFormats';

export const createSetFilters = (filtersVar, filteredResultsVar, searchResultsVar) => {
  return (newFilters) => {
    filtersVar(newFilters);
    const filteredResults = applyFiltersToSearchResults(newFilters, searchResultsVar);
    filteredResultsVar(filteredResults);
  };
};

export const createClearFilters = (filtersVar, filteredResultsVar, searchResultsVar) => {
  return () => {
    const currentFilters = filtersVar();
    const currentSearchResults = searchResultsVar();
    const filtersToSave = {
      stops: {
        nonStop: {
          disabled: currentFilters.stops.nonStop.disabled,
          selected: false,
        },
        oneStop: {
          disabled: currentFilters.stops.oneStop.disabled,
          selected: false,
        },
        twoStops: {
          disabled: currentFilters.stops.twoStops.disabled,
          selected: false,
        },
      },
      flightTimes: {
        landing: {
          ...currentFilters.flightTimes.landing,
          selected: [
            currentFilters.flightTimes.landing.minDateTime,
            currentFilters.flightTimes.landing.maxDateTime,
          ],
        },
        takeOff: {
          ...currentFilters.flightTimes.takeOff,
          selected: [
            currentFilters.flightTimes.takeOff.minDateTime,
            currentFilters.flightTimes.takeOff.maxDateTime,
          ],
        },
      },
      minMaxPrice: {
        ...currentFilters.minMaxPrice,
        selected: currentFilters.minMaxPrice.max,
      },
      airlines: currentFilters.airlines.map((airlineFilter) => {
        return { ...airlineFilter, selected: false };
      }),
      classes: currentFilters.classes.map((mappedClass) => ({ ...mappedClass, selected: false })),
    };
    filtersVar(filtersToSave);
    filteredResultsVar((currentSearchResults && currentSearchResults.matchingFlights) || []);
  };
};

const buildSelectedFormatForTimesFilter = (timesObject) => {
  const splitMinDateTime = timesObject.minDateTime.split(':');
  const minDateTime = convertDateToMilliseconds(`${splitMinDateTime[0]}:00:${splitMinDateTime[2]}`);
  const splitMaxDateTime = timesObject.maxDateTime.split(':');
  const maxDateTime =
    convertDateToMilliseconds(`${splitMaxDateTime[0]}:00:${splitMaxDateTime[2]}`) +
    MILLISECONDS_IN_AN_HOUR;
  return {
    minDateTime,
    maxDateTime,
    selected: [minDateTime, maxDateTime],
  };
};

const getMinimumNumberForPriceSlider = (minFilterValue) => {
  let minForPriceSlider = minFilterValue;
  if (minForPriceSlider % PRICE_FILTER_STEP !== 0) {
    minForPriceSlider =
      PRICE_FILTER_STEP * (parseInt(minForPriceSlider / PRICE_FILTER_STEP, 10) + 1);
  }
  return minForPriceSlider;
};

export const createSetFiltersFromSearchResults = (filtersVar) => {
  return (newFilters) => {
    const filtersToSave = {
      stops: {
        nonStop: {
          disabled: newFilters && newFilters.stops ? !newFilters.stops.nonStop : true,
          selected: false,
        },
        oneStop: {
          disabled: newFilters && newFilters.stops ? !newFilters.stops.oneStop : true,
          selected: false,
        },
        twoStops: {
          disabled: newFilters && newFilters.stops ? !newFilters.stops.twoStops : true,
          selected: false,
        },
      },
      flightTimes:
        newFilters && newFilters.flightTimes
          ? {
              landing: buildSelectedFormatForTimesFilter(newFilters.flightTimes.landing),
              takeOff: buildSelectedFormatForTimesFilter(newFilters.flightTimes.takeOff),
            }
          : {
              landing: { maxDateTime: 0, minDateTime: 0, selected: [0, 0] },
              takeOff: { maxDateTime: 0, minDateTime: 0, selected: [0, 0] },
            },
      minMaxPrice:
        newFilters && newFilters.minMaxPrice
          ? {
              currency: newFilters.minMaxPrice.min.currency,
              min: Math.floor(newFilters.minMaxPrice.min.value),
              minForPriceSlider: getMinimumNumberForPriceSlider(newFilters.minMaxPrice.min.value),
              max: Math.ceil(newFilters.minMaxPrice.max.value),
              selected: Math.ceil(newFilters.minMaxPrice.max.value),
            }
          : { currency: '', max: 0, min: 0, minForPriceSlider: 0, selected: 0 },
      airlines: newFilters
        ? [...newFilters.airlines]
            .sort((airline1, airline2) => airline1.name.localeCompare(airline2.name))
            .map((unmappedAirline) => {
              return {
                code: unmappedAirline.code,
                name: unmappedAirline.name,
                selected: false,
              };
            })
        : [],
      classes: newFilters
        ? newFilters.classes
            .filter((unmappedClass) => unmappedClass.cabinClass.code !== 'ALL')
            .map((unmappedClass) => {
              return {
                code: unmappedClass.cabinClass.code,
                defaultName: unmappedClass.cabinClass.name,
                disabled: !unmappedClass.enabled,
                selected: false,
              };
            })
        : defaultClassFilters,
    };
    filtersVar(filtersToSave);
  };
};
